import { render, staticRenderFns } from "./MarkdownArgument.vue?vue&type=template&id=46e87902&scoped=true&"
import script from "./MarkdownArgument.vue?vue&type=script&lang=js&"
export * from "./MarkdownArgument.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownArgument.vue?vue&type=style&index=0&id=46e87902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e87902",
  null
  
)

export default component.exports